import React from 'react'
import LOGO_White from '../Images/LOGO_White.png'

function Footer() {
    const footerYear = new Date().getFullYear()

  return (
    <footer className="bg-slate-800 text-white">
      <div className='max-w-7xl mx-auto px-6 lg:px-8 py-12'>
        <div className='grid md:grid-cols-2 gap-8 items-start'>
          <div className='space-y-4'>
            <a href='/' className='flex items-center group'>
              <img 
                  src={LOGO_White}
                  className='h-12 w-12 group-hover:scale-105 transition-transform duration-200'
              />
              <div className='ml-3 flex flex-col font-serif text-xl lg:text-2xl leading-tight'>
                  <span>Wallace Software</span>
                  <span>Consulting, LLC.</span>
              </div>
            </a>
            <p className='text-slate-400 text-sm'>
              Professional digital solutions for small businesses
            </p>
          </div>
          
          <div className='flex flex-col space-y-4 md:items-end md:text-right'>
            <div className='space-y-2'>
              <h4 className='font-semibold text-slate-200 mb-3'>Contact Information</h4>
              <a 
                href='mailto:james@wallacesoftware.io' 
                className='flex items-center gap-2 text-slate-300 hover:text-blue-400 transition-colors duration-200 md:justify-end'
              >
                <svg className='w-4 h-4' fill='currentColor' viewBox='0 0 24 24'>
                  <path d='M12 12.713l-11.985-9.713h23.97l-11.985 9.713zm0 2.574l-12-9.725v15.438h24v-15.438l-12 9.725z'/>
                </svg>
                james@wallacesoftware.io
              </a>
              <a 
                href='https://maps.google.com/?q=5 Market St, Amesbury, Massachusetts 01913' 
                className='flex items-start gap-2 text-slate-300 hover:text-blue-400 transition-colors duration-200 md:justify-end'
                target='_blank'
                rel='noopener noreferrer'
              >
                <svg className='w-4 h-4 mt-0.5 flex-shrink-0' fill='currentColor' viewBox='0 0 24 24'>
                  <path d='M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z'/>
                </svg>
                <span>
                  5 Market Square Ste. 206A<br/>
                  Amesbury, MA 01913
                </span>
              </a>
            </div>
          </div>
        </div>
        
        <div className='border-t border-slate-700 mt-8 pt-6'>
          <p className='text-slate-400 text-sm text-center'>
            Copyright &copy; {footerYear} Wallace Software Consulting, LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer